// sx style objects shared by InvoiceItems, InvoicePayments and AuthorizationHoldItems.

const titleRowSx = {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '0.75rem',
  marginRight: '0.5rem',
};

const listSx = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: 'flex-start',
};

const listItemSx = (theme) => ({
  width: '100%',
  padding: '0 4px 0 0',
  '&:not(:last-of-type)': {
    borderBottom: `1px solid ${theme.palette.common.greyLight}`,
  },
});

const invoiceActionButtonSx = {
  fontSize: '0.75rem',
};

const dividerSx = {
  margin: '0 0.5rem',
};

const addItemButtonSx = {
  marginRight: '0.75rem',
};

const resumeSx = {
  backgroundColor: '#F9F9F9',
  borderRadius: '4px',
  padding: '0.5rem 1rem',
};

const totalSx = {
  fontSize: '1rem',
  color: 'primary.main',
};

const buttonSx = (theme) => ({
  fontSize: theme.typography.pxToRem(13),
  textTransform: 'capitalize',
});

// Class names handed to CollapseCard's `customClasses` prop (which expects
// className strings); their styles are defined by collapseCardHostSx, applied
// on the container wrapping the CollapseCard instances.
const collapseCardClassNames = {
  root: 'invoice-collapse-card-root',
  box: 'invoice-collapse-card-box',
  buttonClass: 'invoice-collapse-card-button',
};

const collapseCardHostSx = (theme) => ({
  [`& .${collapseCardClassNames.root}`]: {
    marginTop: 0,
    marginBottom: '20px',
    '& button': {
      borderRadius: '4px',
    },
  },
  [`& .${collapseCardClassNames.box}`]: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
  },
  [`& .${collapseCardClassNames.buttonClass}`]: {
    backgroundColor: theme.palette.tables.header,
    border: `1px solid ${theme.palette.dividers.primary}`,
    boxShadow: 'none',
    color: theme.palette.widgets.text.primary,
    padding: '6px 24px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: theme.palette.tables.header,
      border: `1px solid ${theme.palette.dividers.primary}`,
      boxShadow: 'none',
      color: theme.palette.widgets.text.primary,
    },
  },
});

const listTextSx = (theme) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '10px',
  '& .MuiListItemText-primary': {
    color: theme.palette.text.subtitle,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
  },
  '& .MuiListItemText-secondary': {
    color: theme.palette.common.lightNavy,
    fontSize: theme.typography.pxToRem(13),
    wordBreak: 'break-word',
    textAlign: 'right',
  },
});

export {
  titleRowSx,
  listSx,
  listItemSx,
  invoiceActionButtonSx,
  dividerSx,
  addItemButtonSx,
  resumeSx,
  totalSx,
  buttonSx,
  collapseCardClassNames,
  collapseCardHostSx,
  listTextSx,
};
